$(document).ready(function () {
  var selectors = {
    footer: ".site-footer",
    newsletter: ".site-footer__newsletter",
    successMessage: ".form-message--success"
  };

  var $footerForm = $('.footer-contact-form');

  $footerForm.on('submit', function(e) {
    e.preventDefault();
    var email = $('[data-newsletter-form-email-footer]').val();
    var $modalbackdrop = $('#modalbackdrop');
    var $dataNewsletterFormContent = $('[data-newsletter-form-content]');
    var $dataNewsletterFormContentSubmitted = $('[data-newsletter-form-content-sumitted]');
    var $wrapper = $('[data-newsletter-form]');
    if ($wrapper.length) {
      if (email) {
        $('[data-newsletter-form-email]').val(email);
        $('[data-newsletter-form-email]').parents('[data-form-field]').addClass('field--has-value');
      }
      $wrapper.css('display', 'block');
      $wrapper.css('opacity', 1);
      $modalbackdrop.css('display', 'block');
      $dataNewsletterFormContent.css('display', 'block');
      $dataNewsletterFormContentSubmitted.css('display', 'none');
    }
  });

  //Disable /challenge submit button after being submitted
  if (window.location.pathname.includes('challenge')){
    $('form').submit(function(){
      $(this).children('input[type=submit]').prop('disabled', true);
    });
  }

});
